import React from 'react';
import clsx from 'clsx';

export const WarningIcon = props => {
  return (
    <span
      className={clsx(props.className, 'solstice-icon- solstice-icon-warning')}
    />
  );
};
